import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {NewGiftsDto, OwnedGiftDto} from "@/store/gift/types";
import {Link} from "@/scenes.ui/link";
import {SpaceTr, Tr, TrSpace} from "@/i18n/i18n";
import {GiftUtils} from "@/utils/gift-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class NewGiftPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ng: NewGiftsDto, acceptCallback: (giftId: number) => unknown,
                acceptAllCallback: () => unknown, profileCallback: (playerId: number) => unknown) {
        super(scene, canvas, Tr('gft.new'));

        let g: OwnedGiftDto = ng.gift;

        let nameText = TextUtils.addTextByFamily(scene, (ng.count > 1 ? TrSpace('u.have') + ng.count + SpaceTr('n.g') : Tr('ne.g')).toUpperCase(),
            0, -180, '#ffd465', 18, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, 0, -120, GiftUtils.getAtlas(g.giftId), g.giftId);

        let self = this;
        let sender = new Link(scene, 10 * CU.S, -65 * CU.S, g.presenterName, () => {
            self.close();
            profileCallback(g.presenterId)
        }, '#70ff6a', 16, 0.5);

        let from = TextUtils.addTextAdvanced(scene, TrSpace('from2'), sender.getBounds().left / CU.S - 4, sender.y / CU.S + 1,
            '#c6c6c6', 14, 'normal', 420, 'center', 2, Fonts.ARIAL_MT).setOrigin(1, 0.5);

        let blockFirst = TextUtils.addTextAdvanced(scene, g.text, 0, -5,
            '#f6f6f6', NewGiftPanel.getFontSize(g.text.length), 'normal', 420, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, sender, from, blockFirst]);

        if (ng.count > 1) {
            this.addCustomButton(-100, 150, Tr('acpt.all'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
                acceptAllCallback();
            });

            this.addApproveButton(100, Tr('nxt'), g, acceptCallback);
        } else {
            this.addApproveButton(0, Tr('acpt'), g, acceptCallback);
        }
    }

    public static getFontSize(length: number) {
        if (length < 30) {
            return 18;
        } else if (length < 70) {
            return 16;
        } else if (length < 140) {
            return 15;
        } else if (length < 170) {
            return 14;
        } else if (length < 210) {
            return 13;
        } else if (length < 250) {
            return 12;
        }
        return 11;
    }

    private addApproveButton(x: number, name: string, g: OwnedGiftDto, acceptCallback: (giftId: number) => unknown) {
        this.addCustomButton(x, 150, name, Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.NEW_GIFT, () => {
            acceptCallback(g.id);
        });
    }

    protected onClose(): void {

    }

}
